/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { IpUserMiddlewaresService } from './ip-middlewares.service';

/**
 * @internal
 * No limitations are applied for Paid users
 */
export default class PaidUsersMiddleware extends IpUserMiddlewaresService {}
